import { PRICING_INDICATOR_EXPERIMENT_KEY } from '../../utils';

export const PRICING_INDICATOR_BUCKETED_COOKIE = `convert_bucketed_${PRICING_INDICATOR_EXPERIMENT_KEY}`;
